import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';
import { forkJoin, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonApi } from './api/common.api';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { ApiUrls, Constants } from 'src/app/config/constants';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {

  constructor(
    private commonApi: CommonApi,
    private commonService: CommonService,
    private storageService: StorageService
  ) { }

  homegetProductsListNew(url: any) {
    return forkJoin({
      masterCatalogData: this.commonApi.getCDNLink(url.masterCatalogData)
    }).pipe(catchError((err) => this.errorHandler(err)), map(({ masterCatalogData }) => ({ masterCatalogData })));
  }

  homegetProductsList(url: any) {
    return forkJoin({ masterCatalogData: this.commonApi.getCDNLink(url.masterCatalogData) }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ masterCatalogData }) => ({ masterCatalogData })));
  }

  getmerchantListArray(category: any) {
    const url = `${environment.baseUrl + ApiUrls.stores}?limit=10&offset=2&category=${category}`;
    return this.commonApi.getDataByUrl(url);
  }

  getSplashApi() {
    const url = environment.baseUrl + ApiUrls.splash;
    return this.commonApi.getDataByUrl(url);
  }

  getcatogoriesList() {
    const url = `${environment.baseUrl + ApiUrls.splash}`;
    return this.commonApi.getDataByUrl(url);
  }

  getCatalogList() {
    const storeId =
      this.commonService.getUserData() &&
        this.commonService.getUserData().shopId
        ? this.commonService.getUserData().shopId
        : this.storageService.getItem(Constants.SHOP_ID)
          ? this.storageService.getItem(Constants.SHOP_ID)
          : this.commonService.getUserData().userId;
    const url = `${environment.baseUrl + ApiUrls.catalog.retailerCatalog + storeId}`;
    return this.commonApi.getDataByUrl(url).pipe(catchError((err) => this.errorHandler(err)));
  }

  insertCatalogData(data: any) {
    const storeId = this.commonService.getUserData() && this.commonService.getUserData().shopId
      ? this.commonService.getUserData().shopId : this.storageService.getItem(Constants.SHOP_ID)
        ? this.storageService.getItem(Constants.SHOP_ID) : this.commonService.getUserData().userId
    const url = `${'/rms/apis/v2/catalog/'}${storeId}`;
    return this.commonApi.putData(url, data).pipe(catchError((err) => this.errorHandler(err)));
  }

  updateCatalogData(data: any) {
    const storeId = this.commonService.getUserData() && this.commonService.getUserData().shopId
      ? this.commonService.getUserData().shopId : this.storageService.getItem(Constants.SHOP_ID)
        ? this.storageService.getItem(Constants.SHOP_ID) : this.commonService.getUserData().userId
    const url = `${'/rms/apis/v2/catalog/update/'}${storeId}`;
    return this.commonApi.putData(url, data).pipe(catchError((err) => this.errorHandler(err)));
  }

  addCatalogData(data: any) {
    const storeId =
      this.commonService.getUserData() &&
        this.commonService.getUserData().shopId
        ? this.commonService.getUserData().shopId
        : this.storageService.getItem(Constants.SHOP_ID)
          ? this.storageService.getItem(Constants.SHOP_ID)
          : this.commonService.getUserData().userId;
    const url = `${ApiUrls.retailerCatalog}${storeId}`;
    const productData = {
      products: data,
    };
    return this.commonApi.postData(url, productData);
  }

  addTopItemsCatalog(data: any) {
    const storeId = this.commonService.getUserData() && this.commonService.getUserData().shopId
      ? this.commonService.getUserData().shopId : this.storageService.getItem(Constants.SHOP_ID)
    const url = `${'/rms/apis/v2/catalog/addTopProducts/'}${storeId}`;
    return this.commonApi.putData(url, data).pipe(catchError((err) => this.errorHandler(err)));
  }

  updateSellingType(data: any) {
    const storeId = this.commonService.getUserData() && this.commonService.getUserData().shopId
      ? this.commonService.getUserData().shopId : this.storageService.getItem(Constants.SHOP_ID)
    const url = `${'/rms/apis/v2/catalog/addServiceFlag/'}${storeId}`;
    return this.commonApi.putData(url, data).pipe(catchError((err) => this.errorHandler(err)));
  }

  private errorHandler(err: any) {
    this.commonService.toast(err.error.errorMessage);
    return throwError(err);
  }
}
